import React from 'react';
import Layout from '../../components/Layout';
import HeroSection from './components/HeroSection';
import KeyStats from './components/KeyStats';
import WhyUEExists from './components/WhyUEExists';
import PlatformPreview from './components/PlatformPreview';
import TrustSignals from './components/TrustSignals';
import CorporateCTA from './components/CorporateCTA';

const Homepage = () => {
  return (
    <Layout>
      <HeroSection />
      <KeyStats />
      <WhyUEExists />
      <PlatformPreview />
      <TrustSignals />
      <CorporateCTA />
    </Layout>
  );
};

export default Homepage;
